import type {HotelListLoadedEventAction} from '@/redux/middleware/googleTagManager/types';

export const mapHotelChangeActionToEvent = (
  action?: 'sort' | 'filter' | 'search',
  isLazyLoad?: boolean
): HotelListLoadedEventAction => {
  switch (action) {
    case 'search': {
      return isLazyLoad ? 'search_hotel_list_lazyload' : 'search_hotel_list';
    }
    case 'sort': {
      return isLazyLoad ? 'sort_hotel_list_lazyload' : 'sort_hotel_list';
    }
    case 'filter': {
      return isLazyLoad ? 'filter_hotel_list_lazyload' : 'filter_hotel_list';
    }
    default: {
      return isLazyLoad ? 'hotel_list_lazyload' : 'hotel_list_loaded';
    }
  }
};
